import {FormFieldBaseSupplier} from './form-fieldbase-supplier';

export class FormFieldTreeSupplier extends FormFieldBaseSupplier<string> {

  cols: { field, header}[] = [];
  tableHeight;
  options: any[] = [];
  controlType='tree';

  constructor(options: any) {
    super(options);
    this.cols=options['cols'];
    this.options = options['options'] || [];
    this.tableHeight=options['tableHeight'];
  }

}
